import { useContext } from "react";
import { FormContext } from "../FormProvider";

export const useForm = () => useContext(FormContext);